import type { SVGProps } from 'react';

/**
 * Dataset — Tabellen-Stack mit Header-Row.
 *
 * Domain-spezifischer Ersatz fuer `Database` aus lucide-react. Bewusst im
 * Lucide-Stil gehalten: 24x24 viewBox, stroke 1.5, strokeLinecap="round",
 * keine Fills (Akzent-Cells dezent via opacity statt fill).
 */
export function DatasetIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="14" x2="21" y2="14" />
      <line x1="9" y1="9" x2="9" y2="20" />
      <line x1="15" y1="9" x2="15" y2="20" />
    </svg>
  );
}
